import { Notice } from "../models/notice";
import { atom } from "jotai";

export const editingNoticeAtom = atom<Notice | null>(null);
